import {
  apiClient,
} from "./apiClient";

import type {
  CancelSupplierOpeningBalanceInput,
  CancelSupplierOpeningBalanceResult,
  CreateSupplierOpeningBalanceInput,
  CreateSupplierOpeningBalanceResult,
  SupplierOpeningBalanceDetailsResult,
  SupplierOpeningBalancesPageResult,
  SupplierOpeningBalancesQuery,
  SupplierOpeningBalanceSummary,
  UpdateSupplierOpeningBalanceInput,
  UpdateSupplierOpeningBalanceResult,
} from "../types/supplier-opening-balances.types";


function supplierBasePath(
  supplierId: string,
): string {
  return `/suppliers/${encodeURIComponent(
    supplierId,
  )}/opening-balances`;
}


function buildQueryString(
  query:
    SupplierOpeningBalancesQuery = {},
): string {
  const params =
    new URLSearchParams();

  if (query.currencyCode) {
    params.set(
      "currencyCode",
      query.currencyCode,
    );
  }

  if (query.balanceType) {
    params.set(
      "balanceType",
      query.balanceType,
    );
  }

  if (query.status) {
    params.set(
      "status",
      query.status,
    );
  }

  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }

  if (query.cursor) {
    params.set(
      "cursor",
      query.cursor,
    );
  }

  if (
    query.limit !==
    undefined
  ) {
    params.set(
      "limit",
      String(query.limit),
    );
  }

  const queryString =
    params.toString();

  return queryString
    ? `?${queryString}`
    : "";
}


export const supplierOpeningBalancesApi = {

  async list(
    supplierId: string,
    query:
      SupplierOpeningBalancesQuery = {},
  ): Promise<SupplierOpeningBalancesPageResult> {
    return apiClient.get<
      SupplierOpeningBalancesPageResult
    >(
      `${supplierBasePath(
        supplierId,
      )}${buildQueryString(
        query,
      )}`,
    );
  },


  async getById(
    supplierId: string,
    balanceId: string,
  ): Promise<SupplierOpeningBalanceDetailsResult> {
    return apiClient.get<
      SupplierOpeningBalanceDetailsResult
    >(
      `${supplierBasePath(
        supplierId,
      )}/${encodeURIComponent(
        balanceId,
      )}`,
    );
  },


  async getSummary(
    supplierId: string,
  ): Promise<SupplierOpeningBalanceSummary> {
    return apiClient.get<
      SupplierOpeningBalanceSummary
    >(
      `${supplierBasePath(
        supplierId,
      )}/summary`,
    );
  },


  async create(
    supplierId: string,
    input:
      CreateSupplierOpeningBalanceInput,
  ): Promise<CreateSupplierOpeningBalanceResult> {
    return apiClient.post<
      CreateSupplierOpeningBalanceResult
    >(
      supplierBasePath(
        supplierId,
      ),
      input,
    );
  },


  async update(
    supplierId: string,
    balanceId: string,
    input:
      UpdateSupplierOpeningBalanceInput,
  ): Promise<UpdateSupplierOpeningBalanceResult> {
    return apiClient.patch<
      UpdateSupplierOpeningBalanceResult
    >(
      `${supplierBasePath(
        supplierId,
      )}/${encodeURIComponent(
        balanceId,
      )}`,
      input,
    );
  },


  async cancel(
    supplierId: string,
    balanceId: string,
    input:
      CancelSupplierOpeningBalanceInput,
  ): Promise<CancelSupplierOpeningBalanceResult> {
    return apiClient.post<
      CancelSupplierOpeningBalanceResult
    >(
      `${supplierBasePath(
        supplierId,
      )}/${encodeURIComponent(
        balanceId,
      )}/cancel`,
      input,
    );
  },
};